export enum UserGroupsEnum {
    EXECUTIVE = "Executive",
    MANAGER = "Manager",
    ADMIN = "Admin",
    PROMOTOR = "Promotor"
}
